import { html, nothing, render } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import { onChangeAny } from "@escapio/portal/state/travelData";
import bookingSvg from "@docroot/public/img/portal/adaptive/bookingdotcom.svg";
import { langId } from "@escapio/shared/l10n/lang-id";
import { formatBookingRedirectUrl } from "@escapio/portal/components/format-booking-redirect-url";

const getScoreWording = score => {
	if (score >= 9.5) {
		return translate("hotel_review_score_95");
	}
	if (score >= 9) {
		return translate("hotel_review_score_90");
	}
	if (score >= 8.6) {
		return translate("hotel_review_score_86");
	}
	if (score >= 8) {
		return translate("hotel_review_score_80");
	}
	if (score >= 7) {
		return translate("hotel_review_score_70");
	}
	return null;
};

customElements.define(
	"esc-booking-review-link",
	class extends HTMLElement {
		connectedCallback() {
			const score = this.getAttribute("score") / 10;
			this.scoreWording = getScoreWording(score);
			const formatter = new Intl.NumberFormat(langId, {
				minimumFractionDigits: 1,
				maximumFractionDigits: 1,
			});
			this.score = formatter.format(score);
			onChangeAny(() => this.render());
			this.render();
		}

		render() {
			const template = html`<a
				href=${this.redirectUrl}
				target="_blank"
				rel="noopener nofollow"
				class="-profile__review-section__link"
			>
				<span class="-profile__review-section__left">
					<span class="-profile__review-section__label"
						>${translate("hotel_reviews_label")}</span
					>
					<span class="-profile__review-section__booking-logo"
						>${bookingSvg}</span
					>
				</span>
				<span class="-profile__review-section__right">
					<span class="-profile__review-section__score">${this.score}</span>
					${
						this.scoreWording
							? html`<span
									class="-profile__review-section__score-label ellipsis"
									>${this.scoreWording}</span
								>`
							: nothing
					}
					${
						this.reviewCount
							? html`<span class="-profile__review-section__count ellipsis"
									>${
										this.reviewCount == 1
											? translate(
													"hotel_reviews_count_singular",
													this.reviewCount,
												)
											: translate(
													"hotel_reviews_count_plural",
													this.reviewCount,
												)
									}
								</span>`
							: nothing
					}
				</span>
			</a>`;
			render(template, this, { host: this });
		}

		get redirectUrl() {
			return formatBookingRedirectUrl(
				this.getAttribute("endpoint"),
				this.getAttribute("token"),
				"Profil-Bewertungen",
			);
		}

		get reviewCount() {
			return this.getAttribute("review-count");
		}
	},
);
